import type React from 'react';
import Icon from '2-core-elements/Icon/Icon';

interface FormFieldErrorProps {
  message: string;
}

const FormFieldError: React.FC<FormFieldErrorProps> = ({ message }) => {
    return (
        <div className="form-error">
            <Icon icon="cross-circle" />
            <span>{message}</span>
        </div>
    );
};

export default FormFieldError;
